import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="category"
export default class extends Controller {
  static targets = ["select"]

  categoryKeys = ["brand", "large", "medium", "small"]

  connect() {
    const categoryDataElement = this.element.querySelector("[data-category-categories]")
    if (categoryDataElement) {
      const data = categoryDataElement.dataset.categoryCategories
      this.categories = JSON.parse(data)
    } else {
      console.error("Category data element not found")
    }
  }

  submit() {
    if (typeof this.element.requestSubmit === 'function') {
      this.element.requestSubmit()
    }
  }

  update(event) {
    const currentSelect = event.target
    const currentIndex = this.selectTargets.indexOf(currentSelect)

    if (currentIndex === -1) {
      console.error("The current select element is not found in targets")
      return
    }

    const selectedId = parseInt(currentSelect.value)
    const nextSelect = this.selectTargets[currentIndex + 1]

    if (nextSelect) {
      const categoryKey = this.categoryKeys[currentIndex + 1]
      const nextCategory = this.categories[categoryKey] || []
      const nextOptions = nextCategory.filter((item) => item.parentId === selectedId)

      nextSelect.innerHTML = '<option value="">선택해주세요</option>' + nextOptions
        .map((option) => `<option value="${option.id}">${option.name}</option>`)
        .join("")

      this.selectTargets.slice(currentIndex + 2).forEach((select) => {
        select.innerHTML = '<option value="">선택해주세요</option>'
      })
    }
    this.submit()
  }
}
